<template>
  <main id="content">
    <section class="hero">
      <b-container>
        <b-row>
          <b-col md>
            <h2>Dashboard</h2>
            <p class="mb-0">Welcome to the dashboard that's built for you.</p>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="less-padding">
      <b-container>
        <b-row class="text-center">
          <b-col>
            <router-link to="/settings/subscriptions">
              <div class="h1 mb-3">
                <font-awesome-icon icon="folder-open" />
              </div>
              <div class="h5">Subscriptions</div>
            </router-link>
          </b-col>
          <!-- <b-col>
						<router-link to="/datalogs">
							<div class="h1 mb-3"><font-awesome-icon icon="faDatabase" /></div>
							<div class="h5">Datalogs</div>
						</router-link>
          </b-col>-->
          <b-col>
            <router-link to="/settings/invoices">
              <div class="h1 mb-3">
                <font-awesome-icon icon="file" />
              </div>
              <div class="h5">Invoices</div>
            </router-link>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <!-- <section class="less-padding">
			<b-container>
				<b-row>
					<b-col md>
						<h2>Subscriptions</h2>
					</b-col>
					<b-col md class="text-right">
						<b-btn to="/settings/subscriptions" variant="primary">More<font-awesome-icon icon="faArrowRight" /></b-btn>
					</b-col>
				</b-row>
				<div>
					<div v-if="loading1" class="w-100 d-flex justify-content-center pt-5 pb-5 text-muted">
						<font-awesome-icon icon="faSync" size="2x" spin />
					</div>
					<b-row class="mt-3"  v-else>
						<b-col md="4" v-for="(subscription, index) in subscriptions" :key="subscription.subscription.id" class="d-flex align-self-stretch">
							<div class="card card-body" v-if="index < 3">
								<h5 style="text-transform: capitalize">
									{{subscription.subscription.plan_id.replace(/-/g, " ")}}
									<b-badge :class="'badge ' + subscription.subscription.status">{{subscription.subscription.status.replace(/_/g, " ")}}</b-badge>
								</h5>
								<div><strong>Subscription ID:</strong> {{subscription.subscription.id}}</div>
								<div><strong>Price:</strong> {{subscription.subscription.currency_code}}{{subscription.subscription.plan_unit_price / 100}}/{{subscription.subscription.billing_period_unit}}</div>
								<div><strong>Created on:</strong> {{new Date(subscription.subscription.created_at * 1000).toLocaleDateString()}}</div>
								<div v-if="subscription.subscription.next_billing_at"><strong>Next billing on:</strong> {{new Date(subscription.subscription.next_billing_at * 1000).toLocaleDateString()}}</div>
								<div v-if="subscription.subscription.status === 'cancelled'" class="text-danger">
									<div><strong>Cancelled on:</strong> {{new Date(subscription.subscription.cancelled_at * 1000).toLocaleDateString()}}</div>
								</div>
							</div>
						</b-col>
						<b-col md="4" v-for="(add, index) in plsAdds" :key="'plsadd' + index" class="align-self-stretch d-none d-md-flex">
							<div class="card card-body d-flex justify-content-center align-items-center" v-if="index < 3">
								<router-link class="d-flex" to="/settings/subscriptions">
									<font-awesome-icon icon="faPlusCircle" size="3x" class="text-muted" />
								</router-link>
							</div>
						</b-col>
					</b-row>
				</div>
			</b-container>
		</section>
		<section class="pt-5 pb-5">
			<b-container>
				<div class="pt-5 pb-5 d-flex justify-content-center" v-if="loading">
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" class="loader" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
						<path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" transform="rotate(160 25 25)">
							<animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
						</path>
					</svg>
				</div>
				<div v-else>
					<b-table striped fixed hover :fields="fields" :items="results" sort-by="createdAt" :sort-desc="true" stacked="md" :current-page="currentPage" :per-page="maxItems" :filter="filter" @filtered="onFiltered">
						<template slot="view" slot-scope="row">
							<b-btn primary :to="'/datalogs/' + row.item.id">View<font-awesome-icon icon="faArrowRight" /></b-btn>
						</template>
					</b-table>
					<div v-if="totalRows / maxItems > 1" class="d-flex justify-content-center mt-4">
						<b-pagination :total-rows="totalRows" :per-page="maxItems" v-model="currentPage" class="my-0" />
					</div>
				</div>
			</b-container>
    </section>-->
  </main>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => {
    return {
      newSubscription: "",
      plans: [],
      plsAdds: [],
      show: true,
      loading1: false,
      loading2: false,
      results: [],
      currentPage: 1,
      maxItems: 10,
      totalRows: 0,
      filter: null,
      fields: [
        { key: "title", sortable: true },
        { key: "rodLength", sortable: true },
        { key: "rods", sortable: true },
        { key: "createdAt", sortable: true },
        { key: "view", sortable: false }
      ],
      loading: true
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      customer: "getCustomer",
      subscriptions: "getSubscriptions"
    })
  },
  mounted() {
    this.loading2 = true;
    // this.listSubscriptions();
    // databaseGet("https://underground-magnetics.firebaseio.com/um_data_job_table.json", true).then(data => {
    // 	Object.keys(data).forEach((key, id) => {
    // 		let d = new Date(data[key].umJobTime);
    // 		this.results.push({
    // 			title: data[key].umJobTitle,
    // 			id: btoa("drillmaps" + id)
    // 				.replace(/\+/g, "-")
    // 				.replace(/\//g, "_")
    // 				.replace(/\=+$/, ""),
    // 			rodLength: data[key].umJobRodLength + " ft",
    // 			rods: data[key].umDataArrayList.length,
    // 			createdAt:
    // 				d.getFullYear() +
    // 				"-" +
    // 				(d.getMonth() < 9 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1) +
    // 				"-" +
    // 				(d.getDate() > 9 ? d.getDate() : "0" + d.getDate())
    // 		});
    // 	});
    // 	this.loading = false;
    // });
  },
  methods: {
    listSubscriptions() {
      this.loading1 = true;
      this.$store
        .dispatch("fetchUserSubscriptions")
        .then(list => {
          if (list.length < 3) {
            for (let i = 0; i < 3 - list.length; i++) {
              this.plsAdds.push(1);
            }
          }
        })
        .finally(() => {
          this.loading1 = false;
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style lang="scss" scoped>
section.hero,
section.cta {
  padding: 5rem 0;
  background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.75),
      rgba(0, 0, 0, 0.75)
    ),
    url("../assets/directory-bg.png") no-repeat center center;
  background-size: cover;
  color: #fff;
  .search-input {
    min-width: 30vw;
    max-width: 90vw;
  }
}
.loader {
  width: 50px;
  height: 50px;
  opacity: 0.5;
}
</style>
